import React, { useEffect, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import { CompanyNameType } from '../../../../static/types/commonTypes/companyNameType';
import TheSociety from '../../../commonComponents/TheSociety';
import CompanyName from '../../../commonComponents/CompanyName';
import StatusSignature from '../../../commonComponents/StatusSignature';
import { StatusSignatureType } from '../../../../static/types/commonTypes/statusSignatureType';
import HeadOfficeAddress from '../../../commonComponents/HeadOfficeAddress';
import { HeadOfficeAddressType } from '../../../../static/types/commonTypes/headOfficeAddressType';
import { getCityWithPreposition } from '../../../../utils/functions/getCityWithPreposition';
import { ManagerType } from '../../../../static/types/commonTypes/managerType';
import ManagerList from '../../../commonComponents/ManagerList';
import useAppContext from '../../../../hooks/useAppContext';
import { AppContextType } from '../../../../context/AppContext';
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import { FaUpload } from 'react-icons/fa';
import { GoArrowRight } from 'react-icons/go';
import { formatObjectText } from '../../../../utils/functions/formatObjectText';

interface AnnonceProps {
    txtAnnonce: string;
    updateActiveIndex: (index: number) => void;
    updateTxtAnnonce: (newTxt: string) => void;
    updateDenomination: (newTxt: string) => void;
    societyType: string | string[];
    societeSelected: string;
    updatesocieteSelected: (newTxt: string) => void;
}

const CreationSARL: React.FC<AnnonceProps> = ({
    txtAnnonce,
    updateTxtAnnonce,
    updateActiveIndex,
    updateDenomination,
    societyType,
    updatesocieteSelected
}) => {
    const {
        companyName, setCompanyName,
        companyNameValidity, setCompanyNameValidity,
        companyNameChecked, setCompanyNameChecked,

        statusSignature, setStatusSignature,
        statusSignatureValidity, setStatusSignatureValidity,
        statusSignatureChecked, setStatusSignatureChecked,

        theSociety, setTheSociety,
        theSocietyValidity, setTheSocietyValidity,
        theSocietyChecked, setTheSocietyChecked,

        headOfficeAddress, setHeadOfficeAddress,
        headOfficeAddressValidity, setHeadOfficeAddressValidity,
        headOfficeAddressChecked, setHeadOfficeAddressChecked,

        managers, setManagers,
        managersValidity, setManagersValidity,
        managersChecked, setManagersChecked,
        
        lastTab, setLastTab,
        draftFormData, setDraftFormData
    } = useAppContext() as AppContextType;

     const stringifyDraft = ( data: any ) => { return JSON.stringify( data )}
    const parseDraft: any = () => { return draftFormData ? JSON.parse( draftFormData ) : {} }

    const [activeTab, setActiveTab] = useState<string>('companyName');
    const [visitedTabs, setVisitedTabs] = useState(['companyName']);
    const [submissive, setSubmissive] = useState<boolean>(false);

    
    useEffect(() => {
        setLastTab(activeTab);
    }, [activeTab]);

    useEffect(() => {
        // Si on vient d'un brouillon, restaurer l'onglet actif
        if ( lastTab ) {
            setActiveTab(lastTab);
            // Ajouter tous les onglets précédents comme visités
            const tabOrder = ['companyName', 'statusDignature', 'theSociety', 'headOfficeAddress', 'management'];
            const currentTabIndex = tabOrder.indexOf(lastTab);
            const visitedTabsArray = tabOrder.slice(0, currentTabIndex + 1);
            setVisitedTabs(visitedTabsArray);
        }
    }, []);

    const goToSupportPresse = () => {
        updateActiveIndex(2);
    };

    const validate = () => {
        if (!companyNameValidity) {
            setActiveTab('companyName');
        } else if (!statusSignatureValidity) {
            setActiveTab('statusDignature');
        } else if (!theSocietyValidity) {
            setActiveTab('theSociety');
        } else if (!headOfficeAddressValidity) {
            setActiveTab('headOfficeAddress');
        } else if (!managersValidity) {
            setActiveTab('management');
        }
        return companyNameValidity && statusSignatureValidity && theSocietyValidity && headOfficeAddressValidity && managersValidity;
    };

    const switchTab = (tab: string) => {
        if (!visitedTabs.includes(tab)) {
            setVisitedTabs([...visitedTabs, tab]);
        }
        setActiveTab(tab);
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();

        if (validate()) {
            const tempText = `Par ${statusSignature.actNature} du ${statusSignature.actDate}, il a été constitué une ${theSociety.legalForm} ayant les caractéristiques suivantes :
Dénomination : ${companyName.companyName}, ${theSociety.acronym ? `
Sigle: ${theSociety.acronym},` : ""}
Objet social : ${theSociety.object},
Siège social : ${headOfficeAddress.address} ${headOfficeAddress.additionalAddress ?? ""} ${headOfficeAddress.postalCode} ${headOfficeAddress.city},
Capital : ${theSociety.capital} €,
Durée : ${theSociety.duration > 1 ? `${theSociety.duration} ans` : `${theSociety.duration} an`},
Gérance : ${managers.map((manager: ManagerType, index: number) => {
                if (manager.person === "Personne morale") {
                    return `${manager.entityDetails.companyName}, ${manager.entityDetails.legalForm} au capital de ${manager.entityDetails.capital} €, ayant son siège social ${manager.entityDetails.address} ${manager.entityDetails.additionalAddress ?? ""} ${manager.entityDetails.postalCode} ${manager.entityDetails.city}, ${manager.entityDetails.rcs} RCS ${getCityWithPreposition(manager.entityDetails.registrationOffice)},`;
                } else if (manager.person === "Personne physique") {
                    return ` ${manager.personDetails.civility === 'Monsieur' ? 'M.' : 'Mme'} ${manager.personDetails.lastName} ${manager.personDetails.firstName}, demeurant ${manager.personDetails.address} ${manager.personDetails.additionalAddress ?? ""} ${manager.personDetails.postalCode} ${manager.personDetails.city},`;
                }
            }).join(',')}
Immatriculation au RCS ${getCityWithPreposition(headOfficeAddress.registrationOffice)}.`;

            const formattedText = formatObjectText(tempText);
            updateTxtAnnonce(formattedText);
            updateDenomination(companyName.companyName);
            setSubmissive(true);
        }
    };

    const handlePrevious = () => {
        switchTab(getPreviousTab(activeTab));
        setSubmissive(false);
    };


    const getNextTab = (currentTab: string) => {
        switch (currentTab) {
            case 'companyName':
                return 'statusDignature';
            case 'statusDignature':
                return 'theSociety';
            case 'theSociety':
                return 'headOfficeAddress';
            case 'headOfficeAddress':
                return 'management';
            default:
                return currentTab;
        }
    };

    const getPreviousTab = (currentTab: string) => {
        switch (currentTab) {
            case 'statusDignature':
                return 'companyName';
            case 'theSociety':
                return 'statusDignature';
            case 'headOfficeAddress':
                return 'theSociety';
            case 'management':
                return 'headOfficeAddress';
            default:
                return currentTab;
        }
    };

    const handleNext = () => {
        
        let draft = parseDraft()

        // Formatage de theSociety (Objet Social)
        const formattedSociety = {
            ...theSociety,
            object: formatObjectText(theSociety.object)
        };

        // Utilisez formattedSociety pour mettre à jour les données
        setTheSociety(formattedSociety);

        if (activeTab === 'companyName') {
            setCompanyNameChecked(true);
            if (companyNameValidity) {
                const tempDraft = { ...draft, companyName }
                setDraftFormData( stringifyDraft( tempDraft ))
                switchTab(getNextTab('companyName'));
            }
        } else if (activeTab === 'statusDignature') {
            setStatusSignatureChecked(true);
            if (statusSignatureValidity) {
                const tempDraft = { ...draft, statusSignature }
                setDraftFormData( stringifyDraft( tempDraft ))
                switchTab(getNextTab('statusDignature'));
            }
        } else if (activeTab === 'theSociety') {
            setTheSocietyChecked(true);
            if (theSocietyValidity) {
                const tempDraft = { ...draft, theSociety }
                setDraftFormData( stringifyDraft( tempDraft ))
                switchTab(getNextTab('theSociety'));
            }
        } else if (activeTab === 'headOfficeAddress') {
            setHeadOfficeAddressChecked(true);
            if (headOfficeAddressValidity) {
                const tempDraft = { ...draft, headOfficeAddress }
                setDraftFormData( stringifyDraft( tempDraft ))
                switchTab(getNextTab('headOfficeAddress'));
            }
        } else if (activeTab === 'management') {
            setManagersChecked(true);
            if (managersValidity) {
                const tempDraft = { ...draft, managers }
                setDraftFormData( stringifyDraft( tempDraft ))
                setSubmissive(true);
            }
        } else if (activeTab === 'management'){
            setManagersChecked(true)
            if ( managersValidity ) setSubmissive(true)
        }
    };

    // Company Name
    const updateCompanyNameValidity = (isValid: boolean) => setCompanyNameValidity(isValid);
    const updateCompanyName = (data: Partial<CompanyNameType>) => setCompanyName({ ...companyName, ...data });

    // Signing of the Articles of Association
    const updateStatusSignatureValidity = (isValid: boolean) => setStatusSignatureValidity(isValid);
    const updateStatusSignature = (data: Partial<StatusSignatureType>) => setStatusSignature({ ...statusSignature, ...data });

    // The Society
    const updateTheSocietyValidity = (isValid: boolean) => setTheSocietyValidity(isValid);

    // Registered Office Address
    const updateHeadOfficeAddressValidity = (isValid: boolean) => setHeadOfficeAddressValidity(isValid);
    const updateHeadOfficeAddress = (data: Partial<HeadOfficeAddressType>) => setHeadOfficeAddress({ ...headOfficeAddress, ...data });

    const societyTypeOptions = Array.isArray(societyType) ? societyType : [societyType];
const tabs = [
  { key: "companyName", label: "Raison Sociale" },
  { key: "statusDignature", label: "Signature des Status" },
  { key: "theSociety", label: "La Société" },
  { key: "headOfficeAddress", label: "Adresse du Siège Social" },
  { key: "management", label: "La Gérance" },
];
    return (
        <>
                <div className="container my-3">
                <ul className="nav nav-underline">
                    {tabs
                    .filter((t) => t.key === activeTab) 
                    .map((t) => (
                        <li className="nav-item" key={t.key}>
                        <a
                            href={`#${t.key}`}
                            className={`nav-link active`} 
                        >
                            {t.label}
                        </a>
                        </li>
                    ))}
                </ul>
                </div>

            <ToastContainer />

            <form onSubmit={handleSubmit}>
                {activeTab === 'companyName' && (
                    <CompanyName
                        changeCompanyName={updateCompanyName}
                        checked={companyNameChecked}
                        companyName={companyName}
                        onValidationChange={updateCompanyNameValidity}
                    />
                )}

                {activeTab === 'statusDignature' && (
                    <StatusSignature
                        changeStatusSignature={updateStatusSignature}
                        checked={statusSignatureChecked}
                        onValidationChange={updateStatusSignatureValidity}
                        statusSignature={statusSignature}
                    />
                )}

                {activeTab === 'theSociety' && (
                    <TheSociety
                        checked={theSocietyChecked}
                        companyName={companyName}
                        setTheSociety={setTheSociety}
                        theSociety={theSociety}
                        updateCompanyName={updateCompanyName}
                        updateCompanyNameValidity={updateCompanyNameValidity}
                        updateTheSocietyValidity={updateTheSocietyValidity}
                        societyType={[
                            "Société à responsabilité limitée",
                            "Société à responsabilité limitée à capital variable",
                            "Société d'exercice libéral à responsabilité limitée"
                        ]}
                    />
                )}

                {activeTab === 'headOfficeAddress' && (
                    <HeadOfficeAddress
                        changeHeadOfficeAddress={updateHeadOfficeAddress}
                        checked={headOfficeAddressChecked}
                        headOfficeAddress={headOfficeAddress}
                        onValidationChange={updateHeadOfficeAddressValidity}
                    />
                )}

                {activeTab === 'management' && (
                    <div className="row">
                        <strong>
                            Saisir le nom et l'adresse personnelle du (ou des) gérant(s).
                        </strong>
                        <ManagerList
                            labelItem='Gérant'
                            checked={managersChecked}
                            managers={managers}
                            setManagers={setManagers}
                            societyTypeOptions={societyTypeOptions}
                            setManagersValidity={(isValid: boolean) => setManagersValidity(isValid)}
                            addButtonText='Ajouter un gérant'
                            removeButtonText='Supprimer le dernier gérant'
                            draftFieldName = 'managers'
                        />
                        {submissive && (
                            <div className="mt-4">
                                <h4>Texte de l'annonce:</h4>
                                <textarea
                                    className="form-control"
                                    rows={5}
                                    value={txtAnnonce}
                                    disabled
                                />
                            </div>
                        )}
                    </div>
                )}

                <div className='button-container'>
                    <div className="d-flex gap-2">
                        {activeTab !== 'companyName' && (
                            <button
                                color="#F4A261"
                                className="btn-add"
                                type="button"
                                onClick={handlePrevious}
                            >
                                <SlArrowLeft className="icon" style={{ marginRight: '10px', fontSize: '20px' }} />
                                Modifier mon annonce
                            </button>
                        )}

                        {
                            activeTab === 'management' && (
                                <button
                                    type="submit"
                                    onClick={handleNext}
                                >
                                    Mettre à jour mon annonce
                                    <FaUpload className="icon" style={{ marginLeft: '15px', fontSize: '20px' }} />
                                </button>
                        )}

                        {activeTab !== 'management' && (
                            <button
                                color="#F4A261"
                                className="btn-add"
                                type="button"
                                onClick={handleNext}
                            >
                                Suivant
                                <SlArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                            </button>
                        )}

                        {submissive && activeTab === 'management' && (
                            <button
                                color="#F4A261"
                                className="btn-add"
                                type="button"
                                onClick={goToSupportPresse}
                            >
                                Sélection du support
                                <GoArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                            </button>
                        )}
                    </div>
                </div>
            </form>
        </>
    );
};

export default CreationSARL;